import { useState, useCallback } from 'react';

/**
 * A simple toggle hook that returns a boolean and a toggle action.
 *
 * @param {boolean} initialState The initial state, false by default.
 *
 * @returns {Array} An array containing the state, the toggle and set handler.
 */
export default (initialState = false) => {
  const [visible, setVisible] = useState(initialState);

  const toggle = useCallback(() => setVisible(!visible), [visible, setVisible]);

  return [visible, toggle, setVisible];
};
